import { render } from "./partners.vue?vue&type=template&id=0d703821&scoped=true"
import script from "./partners.vue?vue&type=script&lang=js"
export * from "./partners.vue?vue&type=script&lang=js"

import "./partners.vue?vue&type=style&index=0&id=0d703821&scoped=true&lang=css"
import "./partners.vue?vue&type=style&index=1&id=0d703821&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d703821"]])

export default __exports__